import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';

import TabContainer from './tab-container';

const TabRoutes = (props) => {
  const { children } = props;
  const { path } = useRouteMatch();

  // Create array of child nodes to easier pick data
  const childrenArray = React.Children.toArray(children);
  // Redirects to the first child tab if tab name is omitted
  return (
    <Switch>
      {/* Redirect if trailing slash in path */}
      <Redirect from="/:url*(/+)" to={path.slice(0, -1)} />
      {/* Redirect to first tab if path is tab path is missing */}
      <Redirect
        exact
        from={`${path}`}
        to={`${path}/${childrenArray[0].props.route}`}
      />
      <Route path={`${path}/:paramTabName`}>
        <TabContainer {...props} path={path} />
      </Route>
    </Switch>
  );
};

TabRoutes.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TabRoutes;
